import { TextField } from "@mui/material";
import {
  POLICY_STATUS_CONSTATNS,
  usePolicyStatusData,
} from "./policyStatusData";
import searchIcon from "../../../../assets/images/searchIcon.png";

import "./index.scss";

const PolicyStatus = (props) => {
  const { setIsLoading } = props;

  const {
    formattedDate,
    searchPolicyStatus,
    setSearchPolicyStatus,
    policyStatusFormik,
    hasSearchedPolicyStatus,
    setHasSearchedPolicyStatus,
  } = usePolicyStatusData({ setIsLoading });

  return (
    <div className="policy-status">
      <h6 className="policy-status__title">{POLICY_STATUS_CONSTATNS.TITLE}</h6>

      <form
        onSubmit={policyStatusFormik.handleSubmit}
        className="policy-status__form"
      >
        <TextField
          name="policyImei"
          variant="outlined"
          label={POLICY_STATUS_CONSTATNS.IMEI_LABEL}
          value={policyStatusFormik.values.policyImei}
          onChange={(e) => {
            policyStatusFormik.handleChange(e);
            if (e.target.value.trim() === "") {
              setSearchPolicyStatus(null);
              setHasSearchedPolicyStatus(false);
            }
          }}
          onBlur={policyStatusFormik.handleBlur}
          inputProps={{ maxLength: 15 }}
          error={
            policyStatusFormik.touched.policyImei &&
            Boolean(policyStatusFormik.errors.policyImei)
          }
          helperText={
            policyStatusFormik.touched.policyImei &&
            policyStatusFormik.errors.policyImei
          }
          className="policy-status__input"
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#ccc",
              },
              "&:hover fieldset": {
                borderColor: "#999",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1976d2",
                borderWidth: "2px",
              },
            },
            "& .MuiInputLabel-root": {
              "&.Mui-focused": {
                color: "#1976d2",
              },
            },
          }}
        />

        <button type="submit" className="policy-status__search-btn">
          {POLICY_STATUS_CONSTATNS.SEARCH_POLICY_BUTTON}
        </button>
      </form>

      {searchPolicyStatus && (
        <div className="policy-status__result-card">
          <div className="policy-status__card-header">
            <h5 className="policy-status__card-title">
              {POLICY_STATUS_CONSTATNS.POLICY_DETAILS}
            </h5>
          </div>

          <div className="policy-status__details-grid">
            <div className="policy-status__detail-row">
              <dt className="policy-status__label">
                {POLICY_STATUS_CONSTATNS.MOBILE_NUMBER}
              </dt>
              <dd className="policy-status__value">
                {searchPolicyStatus?.customerMobileNumber || "-"}
              </dd>
            </div>

            <div className="policy-status__detail-row">
              <dt className="policy-status__label">
                {POLICY_STATUS_CONSTATNS.USER_NAME}
              </dt>
              <dd className="policy-status__value">
                {searchPolicyStatus?.userName || "-"}
              </dd>
            </div>

            <div className="policy-status__detail-row">
              <dt className="policy-status__label">
                {POLICY_STATUS_CONSTATNS.PLAN_NAME}
              </dt>
              <dd className="policy-status__value">
                {searchPolicyStatus?.planName || "-"}
              </dd>
            </div>

            <div className="policy-status__detail-row">
              <dt className="policy-status__label">
                {POLICY_STATUS_CONSTATNS.POLICY_STATUS}
              </dt>
              <dd className="policy-status__value">
                {searchPolicyStatus?.policyStatus === 0
                  ? "In Active"
                  : searchPolicyStatus?.policyStatus === 1
                  ? "Ready To Be Activated"
                  : searchPolicyStatus?.policyStatus === 2
                  ? "Pending Diagnostic"
                  : searchPolicyStatus?.policyStatus === 3
                  ? "Pending Verification"
                  : searchPolicyStatus?.policyStatus === 4
                  ? "Activated"
                  : searchPolicyStatus?.policyStatus === 5
                  ? "Rejected"
                  : "Verify Again"}
              </dd>
            </div>

            {searchPolicyStatus?.resonsForPending !== "Null" && (
              <div className="policy-status__detail-row">
                <dt className="policy-status__label">
                  {POLICY_STATUS_CONSTATNS.REASON}
                </dt>
                <dd className="policy-status__value">
                  {searchPolicyStatus?.resonsForPending}
                </dd>
              </div>
            )}

            <div className="policy-status__detail-row">
              <dt className="policy-status__label">
                {POLICY_STATUS_CONSTATNS.POLICY_PUNCHING_DATE}
              </dt>
              <dd className="policy-status__value">{formattedDate}</dd>
            </div>
          </div>
        </div>
      )}

      {(!searchPolicyStatus ||
        !hasSearchedPolicyStatus ||
        Object.keys(searchPolicyStatus).length === 0) && (
        <div className="policy-status__empty-state">
          <img
            src={
              hasSearchedPolicyStatus
                ? "https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
                : searchIcon
            }
            alt="Not found"
            className="policy-status__empty-icon"
          />

          <h6 className="policy-status__empty-title">
            {hasSearchedPolicyStatus
              ? POLICY_STATUS_CONSTATNS.POLICY_NOT_FOUND
              : POLICY_STATUS_CONSTATNS.SEARCH_POLICY_BUTTON}
          </h6>

          <p className="policy-status__empty-desc">
            {hasSearchedPolicyStatus
              ? POLICY_STATUS_CONSTATNS.POLICY_NOT_FOUND_DESC
              : POLICY_STATUS_CONSTATNS.ENTER_VALID_IMEI_DESC}
          </p>
        </div>
      )}
    </div>
  );
};

export default PolicyStatus;
